import { ContactActivityType } from '@business/entities/contact';

export function getTypeTitle(type: ContactActivityType) {
  switch (type) {
    case ContactActivityType.leftMessage:
      return 'Left Message';
    case ContactActivityType.noMessage:
      return 'No Message';
    case ContactActivityType.interview:
      return 'Interview';
    case ContactActivityType.interviewInPerson:
      return 'Interview - In Person';
    case ContactActivityType.meeting:
      return 'Meeting';
    case ContactActivityType.other:
      return 'Other';
    case ContactActivityType.note:
      return 'Note';
    case ContactActivityType.sentEmail:
      return 'Email';
    case ContactActivityType.ticket:
      return 'Tickets';
    case ContactActivityType.appointment:
      return 'Appointment';
  }
  return type;
}

export function getTypes() {
  return [
    ContactActivityType.leftMessage,
    ContactActivityType.noMessage,
    ContactActivityType.interview,
    // ContactActivityType.interviewInPerson,
    // ContactActivityType.meeting,
    // ContactActivityType.other,
    ContactActivityType.note,
    ContactActivityType.sentEmail,
    ContactActivityType.ticket,
    ContactActivityType.appointment,
  ];
}
